import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PolygonService} from "../../services/polygons-service.service";
import {ServiceAreaDialogService} from "../../services/service-area-dialog-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class editServiceAreaViewCtrl implements IController {

  serviceArea: any;
  feature: any;
  coordinates: any[];
  onCancel: Function;
  onChangeServiceArea: Function;
  onChangeFeature: Function;
  onSave: Function;

  public serviceAreaTypes: any;
  public searchedAddress: any;
  public showSearch: any;

  public serviceAreaCopy: any
  public featureCopy: any
  public hasPolygonForSave: boolean

  /* @ngInject */
  constructor(private confirmDialogService: ConfirmDialogService, private $log, private polygonService: PolygonService,
              private serviceAreaDialogService: ServiceAreaDialogService, private ServiceAreaConstants) {
    this.serviceAreaTypes = this.ServiceAreaConstants.serviceTypes;
  }

  $onInit() {
    this.searchedAddress = undefined;
    this.showSearch = false;

    this.serviceAreaCopy = angular.copy(this.serviceArea);
    this.featureCopy = angular.copy(this.feature);
    this.hasPolygonForSave = this._hasPolygonForSave();
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.feature || onChangesObj.coordinates) {
      this.featureCopy = angular.copy(this.feature);
      this.hasPolygonForSave = this._hasPolygonForSave();
    }
  }

  _hasPolygonForSave() {
    if (this.coordinates && this.coordinates.length) {
      return true;
    }
    const ring = _.get(this.feature, 'geometry.coordinates[0]');
    return !!(ring && ring.length);
  }

  onGetFeatureByAddress(address) {
    if (address.city && address.country) {
      this.polygonService.getFeatureByAddress(address.city, address.country)
        .then((res: any) => {
          const results = res.data;
          if (results && results.length) {

            const polygon = _.find(results, (r) => {
              return r.geojson.type === 'MultiPolygon' || r.geojson.type === 'Polygon';
            });

            if (polygon) {
              this._onSetGeoJSON(polygon.geojson, address);
            }
          }
        })
        .catch((error) => {
          this.$log.error('Failed to get city from open street map', error);
        })
    }
  }

  onBranchIdsChange(branchIds) {
    this.serviceAreaCopy.branchIds = branchIds;
  }

  onTagsChange(tags) {
    this.serviceAreaCopy.tags = tags;
  }

  onColorChange(color) {
    this.serviceAreaCopy.color = color;
    if (this.featureCopy?.properties) {
      this.featureCopy.properties.fill = color;
      this.featureCopy.properties.stroke = color;
      this.onChangeFeature({feature: this.featureCopy});
    }
  }

  onSaveClicked(form, doReprice) {
    form.$setSubmitted(true);
    if (form.$valid) {
      this.confirmDialogService.confirm('Save Polygon', 'Are you sure you want to save the changes made to this polygon?', event)
        .then(() => {
          this.onSave({feature: this.feature, serviceArea: this.serviceAreaCopy, doReprice: doReprice});
        })
        .catch(() => {
          this.$log.info('Dialog Closed');
        })
    }
  }

  onUploadJSON(event) {
    this.serviceAreaDialogService.uploadGeoJSON(event, this.featureCopy)
      .then((geoJson) => {
        if (geoJson.geometry) {
          this._onSetGeoJSON(geoJson.geometry, undefined, geoJson.properties);
        }
      })
  }

  _onSetGeoJSON(geometry, address, properties?) {
    if (geometry.type === 'MultiPolygon') {
      let coordsIndex: any = 0;
      let length: number = 0;

      _.forEach(geometry.coordinates, (c, index) => {
        if (length < c[0].length) {
          coordsIndex = index;
          length = c[0].length;
        }
      });
      geometry.coordinates = geometry.coordinates[coordsIndex];
    }

    this.featureCopy.geometry.coordinates = _.get(geometry, 'coordinates');
    this.featureCopy.geometry.type = 'Polygon';

    if (properties) {
      this.featureCopy.properties = properties;
    } else {
      this.featureCopy.properties.areaName = _.get(address, 'city');
    }

    this.onChangeFeature({feature: this.featureCopy});
  }

}

angular
  .module('bringoz.admin.service-areas')
  .component('editServiceAreaView', {
    bindings: {
      serviceArea: '<',
      feature: '<',
      coordinates: '<?',
      onCancel: '&',
      onChangeServiceArea: '&',
      onChangeFeature: '&',
      onSave: '&'
    },
    template: require('./edit-service-area-view.html').default,
    controller: editServiceAreaViewCtrl
  });
